<template>
    <div v-if="filterItem && filterItem.subFilters" class="secondary-filter-options">
        <div class="pointer"
             :data-qe-id="`community-filter_${currentFilterKey}-filter_${filterIndex}`"
             @click.prevent="handleSelectedSubFilter()" >
            <label v-if="!isSelectedSubFilter"
                   class="check-container ypo_blue_color">
                <span>{{filterItem.label}}</span>
              <input type="checkbox" :data-qe-id="`community-filter_${currentFilterKey}-filter_checkbox_${filterIndex}`">
                <span class="checkmark"></span>
            </label>
            <div v-if="isSelectedSubFilter" class="secondary-filter-options__checked">
                <v-layout pb-3>
                    <v-flex class="typeAhead__checked" pr-2>
                        <v-icon color="ypo_cta" size="24" class="plus_icon">add_circle</v-icon>
                    </v-flex>
                    <v-flex class="typeAhead__checked">
                        <span class="selected-label bold-font">{{filterItem.label}}</span>
                    </v-flex>
                </v-layout>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'CommunityFilterWithSecondaryOptions',
        props: {
            filterItem: {
                type: Object,
                required: true,
            },
            filterIndex: {
                type: Number,
                required: true,
            },
            activeFilter: {
                type: Object,
                required: true,
            },
            selectedFiltersList: {
                type: Array,
                required: true,
            },
            setCurrentSecondaryOptions: {
                type: Function,
                required: true,
            },
            currentFilterKey: {
                type: String,
                required: true,
                default: '',
            },
            additionalParentCallBack: {
                type: Function,
            },
        },
        methods: {
            handleSelectedSubFilter() {
                this.setCurrentSecondaryOptions(this.filterItem);
                if (this.additionalParentCallBack) {
                    this.additionalParentCallBack();
                }
            },
        },
        computed: {
            isSelectedSubFilter() {
                const { filterItem, selectedFiltersList, activeFilter } = this;
                let isSelected = false;
                if (filterItem && activeFilter && activeFilter.filterKey === filterItem.filterKey && activeFilter.filterValue === filterItem.filterValue) {
                    isSelected = (activeFilter.filterKey === filterItem.filterKey && activeFilter.filterValue === filterItem.filterValue);
                } else if (filterItem && filterItem.subFilters && selectedFiltersList) {
                    filterItem.subFilters.forEach((fItem) => {
                        const itemInSelected = selectedFiltersList
                            .find(sItem => (sItem.filterKey === fItem.filterKey && sItem.filterValue === fItem.filterValue)
                                || (sItem.filterKey === fItem.filterKey && sItem.isTypeAhead));
                        if (itemInSelected) {
                            isSelected = true;
                        }
                    });
                }
                return isSelected;
            },
        },
    };
</script>
<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_commonClasses.scss';
    .secondary-filter-options {
        @extend %ypo_checkbox;
        &__checked {
            padding-bottom: 10px;
        }
        .typeAhead__checked {
            flex: 0 1 auto !important;
        }
        .selected-label {
            color: $ypo-blue;
            position: relative;
            font-size: 16px;
        }
        .plus_icon {
            margin-left: -5px;
        }
        .blocked-filter {
            position: absolute;
            height: 100%;
            width: 100%;
            z-index: 2;
            top: 0;
            left: -2px;
            background-color: transparent;
        }
    }
</style>
<style lang="scss">
    @import '../../common/styles/_colors.scss';
    .secondary-filter-options {
        .v-input--is-label-active {
            .v-input__slot {
                .v-label {
                    font-weight: 600 !important;
                }
            }
        }
    }
</style>
